export default __webpack_public_path__ + "static/media/Sean.95cdfbf9.jpg";